import { useState, Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { LanguageProvider } from "./contexts/language";
import { MenuProvider } from "./contexts/menu";
import { Head } from "./components/helmet";
import { Loader } from "./components/loader";
import { Header } from "./components/header";
import { Layout } from "./components/layout/layout";

import "./styles.css";

const Home = lazy(() => import("./routes/home"));
const About = lazy(() => import("./routes/about"));
const Contact = lazy(() => import("./routes/contact"));
const Events = lazy(() => import("./routes/events"));
const Media = lazy(() => import("./routes/media"));
const Impressum = lazy(() => import("./routes/impressum"));
const WorkWithMe = lazy(() => import("./routes/work-with-me"));

const queryClient = new QueryClient();

export function App() {
  const [showSuccess, setShowSuccess] = useState(false);

  return (
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <Head />
        <BrowserRouter>
          <MenuProvider>
            <AppShell>
              <Suspense
                fallback={
                  <Layout>
                    <Loader />
                  </Layout>
                }
              >
                <Routes>
                  <Route
                    index
                    element={
                      <Home
                        showSuccess={showSuccess}
                        onDismissSuccess={() => setShowSuccess(false)}
                      />
                    }
                  />
                  <Route path="/about" element={<About />} />
                  <Route path="/events" element={<Events />} />
                  <Route path="/work-with-me" element={<WorkWithMe />} />
                  <Route
                    path="/contact"
                    element={<Contact onSuccess={() => setShowSuccess(true)} />}
                  />
                  <Route path="/media/*" element={<Media />} />
                  <Route path="/impressum" element={<Impressum />} />
                </Routes>
              </Suspense>
            </AppShell>
          </MenuProvider>
        </BrowserRouter>
      </LanguageProvider>
    </QueryClientProvider>
  );
}

function AppShell({ children }) {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  return (
    <>
      <Header isHome={isHome} />
      {children}
    </>
  );
}
